// extracted by mini-css-extract-plugin
module.exports = {"Container":"fJi8Y","QuestionsSwitchDifficulty":"kSSJS"};